import { useState } from 'react';
import apiClient from '@/api/axios';
import { reportLeadConversion } from '@/lib/google-ads';

export const useContactForm = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const submitContactForm = async (data) => {
    const { name, email, phone, companyName, message, recaptchaToken } = data;

    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      // Backend'de /landing/contact endpoint'i yok; iletişim de demo-req'e gider
      // (aynı BasvuruRequest: name/email/phone/message/recaptchaToken).
      const response = await apiClient.post('/landing/demo-req', {
        name,
        email,
        phone,
        companyName,
        message,
        recaptchaToken,
      });

      reportLeadConversion(response.status);
      setSuccess(true);
      setLoading(false);
      setError(null);

      return {
        success: true,
        data: response.data,
      };
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'An error occurred';
      setError(errorMessage);
      setLoading(false);
      setSuccess(false);
      return {
        success: false,
        error: errorMessage,
      };
    }
  };

  return {
    submitContactForm,
    loading,
    error,
    success,
  };
};
